import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `BigUrlValue`
};

export function useBigUrlValueStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          display: `inline-block`,
          marginRight: `5px`
        }
      ]
    }),
    []
  );
}
